import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ForgetMeNotIcon } from "../ForgetMeNotIcon";

const FADE = { initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" }, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } };

export function Mission() {
    const { t } = useTranslation();
    return (
        <section className="relative py-32 px-6 rem-petal-bg" data-testid="mission-section">
            <div className="max-w-3xl mx-auto text-center">
                <motion.div {...FADE} className="flex justify-center mb-8">
                    <ForgetMeNotIcon size={64} />
                </motion.div>
                <motion.p {...FADE} transition={{ ...FADE.transition, delay: 0.05 }} className="font-sans text-xs uppercase tracking-[0.3em] text-[#6B7DB8] font-semibold mb-6">
                    {t("mission.eyebrow")}
                </motion.p>
                <motion.h2 {...FADE} transition={{ ...FADE.transition, delay: 0.1 }} className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2D2B2A] leading-tight">
                    {t("mission.headline_part1")} <em className="italic text-[#4A5A95]">{t("mission.headline_emphasis")}</em>
                </motion.h2>
                <motion.p {...FADE} transition={{ ...FADE.transition, delay: 0.2 }} className="mt-10 text-lg text-[#5C5A59] leading-relaxed font-light max-w-2xl mx-auto">
                    {t("mission.body")}
                </motion.p>

                <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.25 }} className="mt-12 max-w-2xl mx-auto rounded-3xl bg-white/70 backdrop-blur p-8 border border-[#E5E1D8]/60" data-testid="mission-research-note">
                    <p className="font-serif italic text-lg text-[#2D2B2A] leading-relaxed">
                        {t("mission.research_quote")}
                    </p>
                    <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[#8A8786]">{t("mission.research_source")}</p>
                    <p className="mt-5 text-sm text-[#5C5A59] leading-relaxed">
                        {t("mission.research_body")}
                    </p>
                </motion.div>
                <motion.p {...FADE} transition={{ ...FADE.transition, delay: 0.3 }} className="mt-12 font-serif italic text-xl text-[#4A5A95]" data-testid="mission-signoff">
                    {t("mission.signoff")}<br/>
                    <span className="text-[#8A8786] not-italic text-sm tracking-[0.2em] uppercase font-sans">{t("mission.signoff_sub")}</span>
                </motion.p>
            </div>
        </section>
    );
}
